<template>
  <div>
    <div>
      <aha-modal
        :closable="false"
        v-if="!isServerConnectable && isTokenValid"
        action-position="justify-center"
        :title="$i18nPresenter.t('Cannot connect to server')"
      >
        <div>
          {{ $i18nPresenter.t('Please reload this page to try again.') }}
        </div>

        <div>
          <template v-if="isSystemStatusActive">
            {{
              $i18nPresenter.t('This is on our side, not your internet connection. We are fixing it. Contact us at')
            }}
          </template>
          <template v-else>
            {{
              $i18nPresenter.t('If the problem still occurs, please check your internet connection or contact us at')
            }}
          </template>
          <a href="mailto:hi@ahaslides.com">hi@ahaslides.com</a>
          {{ $i18nPresenter.t('for support.') }}
        </div>

        <template #action>
          <aha-antd-button
            v-aha-emit-action
            name="reload-button"
            @click="$router.go()"
            data-testid="disconnection-reload-button"
          >
            {{ $i18nPresenter.t('Reload') }}
          </aha-antd-button>
        </template>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { systemStatusState } from '@/services/systemStatus'

export default {
  data() {
    return {
      remainingSeconds: null,
    }
  },
  computed: {
    ...mapState({
      isServerConnectable: (state) => state.indicators.isServerConnectable,
      isTokenValid: (state) => state.isTokenValid,
    }),
    isSystemStatusActive: () => systemStatusState.isActive,
  },
}
</script>
